module.exports = __webpack_public_path__ + "img/y-49.91cb7cd0.png";